<template>
  <!-- 人才招聘 -->
  <div class="recruit-container">
    <h1 class="page-title">在线招聘</h1>
    <div class="table-wrapper">
      <el-table
        :data="tableData"
        style="width: 100%"
        stripe
        :header-cell-style="headerStyle"
        :cell-style="cellStyle">
        <el-table-column
          prop="postName"
          label="职位名称"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="age"
          label="年龄要求"
          min-width="100">
        </el-table-column>
        <el-table-column
          prop="salary"
          label="薪资待遇"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="workYear"
          label="经验要求"
          min-width="100">
        </el-table-column>
        <el-table-column
          prop="workAddress"
          label="工作地点"
          min-width="100">
        </el-table-column>
        <el-table-column
          label="更多"
          min-width="120"
          align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              class="more-btn"
              @click="handleViewDetails(scope.row)">
              查看基本详情 >
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next, jumper"
          :total="total"
          background>
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import recruitedDetailData from '@/data/recruitedDetailData'
  export default {
    name: 'Recruit',
    data() {
      return {
        currentPage: 1,
        pageSize: 20,
        total: recruitedDetailData.length,
        tableData: recruitedDetailData
      }
    },
    methods: {
      headerStyle() {
        return {
          backgroundColor: '#34abfd',
          color: '#fff',
          fontWeight: '700',
          fontSize: '18px',
          textAlign: 'center',
          padding: '16px 0'
        }
      },
      cellStyle() {
        return {
          textAlign: 'center',
          color: 'rgba(0, 0, 0, 0.8)',
          fontSize: '14px',
        }
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`)
      },
      handleViewDetails(row) {
        this.$router.push(`/join/recruit/${row.id}`)
      }
    }
  }
</script>

<style lang="scss" scoped>
.recruit-container {
  width: 100%;
  max-width: 1360px;
  margin: 0 auto;
  padding: 4% 15px 8% 15px;
  box-sizing: border-box;

  .page-title {
    text-align: center;
    font-size: 32px;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 30px;
    font-weight: bold;
  }

  .table-wrapper {
    background: #fff;
    border-radius: 4px;
    padding: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .more-btn {
    color: #409EFF;
    font-size: 14px;

    &:hover {
      color: #66b1ff;
    }
  }

  .pagination-container {
    margin-top: 20px;
    text-align: center;
  }
}

// 响应式布局
@media screen and (max-width: 768px) {
  .recruit-container {
    padding: 10px;

    .page-title {
      font-size: 20px;
      margin-bottom: 20px;
    }

    .table-wrapper {
      padding: 10px;
    }
  }
}
</style>
